import { render, staticRenderFns } from "./ButtonAmazon.vue?vue&type=template&id=dd716540&scoped=true&lang=pug&"
import script from "./ButtonAmazon.vue?vue&type=script&lang=js&"
export * from "./ButtonAmazon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAmazon.vue?vue&type=style&index=0&id=dd716540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd716540",
  null
  
)

export default component.exports